import { URL } from 'api/constants';

// PAYROLL item popup (review 27 Oct): the popup reads the item each time it
// opens (receipt, payment method). The shared `details` endpoint sends no
// 'allow-not-found', so a 404 (an item deleted elsewhere while the list was
// open) would send the page to /not-found (api/instance.ts). The popup's own
// read (store/api/payout `payrollItemDetails`) sends it, so a 404 stays an
// error the popup answers inline ("This item was removed"). The shared
// endpoint is unchanged (e.g. the event P&L bonuses drawer). Same origin on
// Dev / Prod (clix-pos.com/api/v1), so the header needs no CORS allowance
// there, as the Clover reader-status check already does. Kept free of RTK so a
// test can send it through the real axios interceptor.
export const payrollItemDetailsRequest = (id: number) => ({
  method: 'get' as const,
  headers: { 'allow-not-found': 'true' },
  url: URL.GET_PAYOUT_DETAILS.replace(':id', String(id)),
});

/** A 404 from the item read: the item no longer exists (deleted elsewhere). */
export const isItemGone = (error: unknown) =>
  (error as { status?: number } | undefined)?.status === 404;
